module.exports = __webpack_public_path__ + "static/fist-full-d8e345be742f5b33f45543e9a088741f.jpg";